import React, { useState } from 'react';
import { CirclePlus, CircleMinus } from 'lucide-react';
import { Dropdown } from 'primereact/dropdown';

import { FIELD_COMPARISON_OPERATORS } from '../constant/constant';
import { ACTION } from '../../../../constants/form-actions.constant';

const GetConditionRow = ({
  dimensionList,
  action,
  innerRecord,
  widgetFormik,
  filterConditions,
  index,
  quickFilterFor,
}) => {
  const [selectedColumnType, setSelectedColumnType] = useState('string');
  const [selectedOperand, setSelectedOperand] = useState({});

  const compareFieldOptions =
    dimensionList?.length &&
    dimensionList.filter(
      item =>
        item.type === selectedColumnType && item.name !== innerRecord.tableField
    );
  const updateRow = updatedRow => {
    const updatedConditions = [...filterConditions];
    updatedConditions[index] = updatedRow;

    widgetFormik.setFieldValue('custom_properties', {
      ...widgetFormik.values.custom_properties,
      [quickFilterFor]: updatedConditions,
    });
  };
  React.useEffect(() => {
    if (innerRecord?.tableField) {
      const type = dimensionList?.find(
        option => option?.name === innerRecord?.tableField
      )?.type;
      setSelectedColumnType(type);
      setSelectedOperand(
        FIELD_COMPARISON_OPERATORS[type]?.find(
          a => a.value === innerRecord.operator
        )
      );
    }
  }, [innerRecord?.tableField, dimensionList]);

  return (
    <div className="grid grid-nogutter w-full gap-2 mt-2">
      <div className="col-12 md:col">
        <span className="p-float-label">
          <Dropdown
            id="field"
            showClear
            filter
            key={innerRecord.tableField}
            options={dimensionList || []}
            disabled={action === ACTION.VIEW ? true : false}
            value={
              dimensionList?.find(a => a.name === innerRecord.tableField)?.value
            }
            optionLabel="value"
            className="w-full"
            onChange={event => {
              const selectedLabel = event.value;

              const fullObject = dimensionList.find(
                item => item.value === selectedLabel
              );

              setSelectedColumnType(fullObject?.type || '');
              innerRecord.tableField = fullObject?.name || '';
              innerRecord.operator = '';
              innerRecord.compareWithField = '';

              updateRow({ ...innerRecord });
            }}
          />
          <label htmlFor="field">
            Field <span className="text-red-400">*</span>
          </label>
        </span>
      </div>
      <div className="col-12 md:col">
        <span className="p-float-label">
          <Dropdown
            id="operator"
            showClear
            filter
            key={innerRecord.operator}
            options={FIELD_COMPARISON_OPERATORS[selectedColumnType] || []}
            disabled={action === ACTION.VIEW}
            value={
              FIELD_COMPARISON_OPERATORS[selectedColumnType]?.find(
                a => a.value === innerRecord.operator.value
              )?.value || selectedOperand?.value
            }
            optionLabel="label"
            className="w-full"
            onChange={event => {
              const selectedLabel = event.value;

              const fullObject = FIELD_COMPARISON_OPERATORS[
                selectedColumnType
              ]?.find(item => item.value === selectedLabel);
              innerRecord.operator = fullObject;

              updateRow({ ...innerRecord });
            }}
          />
          <label htmlFor="operator">
            Select Operators <span className="text-red-400">*</span>
          </label>
        </span>
      </div>

      <div className="col-12 md:col">
        {innerRecord.tableField && (
          <span className="p-float-label">
            <Dropdown
              id="compareWithField"
              showClear
              filter
              key={innerRecord.compareWithField}
              options={compareFieldOptions}
              disabled={action === ACTION.VIEW}
              value={
                compareFieldOptions.find(
                  item => item.name === innerRecord.compareWithField
                )?.value || null
              }
              onChange={event => {
                const selectedLabel = event.value;

                const fullObject = dimensionList.find(
                  item => item.value === selectedLabel
                );
                innerRecord.compareWithField = fullObject?.name || '';

                updateRow({ ...innerRecord });
              }}
              optionLabel="value"
              className="w-full"
            />
            <label htmlFor="compareWithField">
              Compare With Field <span className="text-red-400">*</span>
            </label>
          </span>
        )}
      </div>

      {action !== ACTION.VIEW && (
        <div className="col-2 md:col-1 flex justify-content-center gap-2 align-items-center">
          {index === 0 ? (
            <CirclePlus
              className="text-primary text-sm w-1rem h-1rem"
              onClick={() => {
                const updatedConditions = [
                  ...filterConditions,
                  {
                    tableField: '',
                    operator: '',
                    compareWithField: '',
                  },
                ];
                filterConditions.push({
                  tableField: '',
                  operator: '',
                  compareWithField: '',
                });
                widgetFormik.setFieldValue('custom_properties', {
                  ...widgetFormik.values.custom_properties,
                  [quickFilterFor]: updatedConditions,
                });
              }}
            />
          ) : (
            filterConditions?.length > 1 && (
              <CircleMinus
                className="text-primary text-sm w-1rem h-1rem"
                onClick={() => {
                  const updatedConditions = filterConditions.filter(
                    (_, i) => i !== index
                  );
                  filterConditions.splice(index, 1);

                  widgetFormik.setFieldValue('custom_properties', {
                    ...widgetFormik.values.custom_properties,
                    [quickFilterFor]: updatedConditions,
                  });
                }}
              />
            )
          )}
        </div>
      )}
    </div>
  );
};

const QuickFilters = ({
  widgetFormik,
  action,
  dimensionList,
  quickFilterFor,
}) => {
  return (
    <>
      <div className="grid w-full grid-nogutter gap-3">
        {widgetFormik.values.custom_properties[quickFilterFor]?.map(
          (record, conditionIndex) => {
            return (
              <>
                <GetConditionRow
                  dimensionList={dimensionList}
                  action={action}
                  innerRecord={record}
                  widgetFormik={widgetFormik}
                  filterConditions={
                    widgetFormik.values.custom_properties[quickFilterFor]
                  }
                  index={conditionIndex}
                  quickFilterFor={quickFilterFor}
                />
              </>
            );
          }
        )}
      </div>
    </>
  );
};

export default QuickFilters;
